module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/report-1353dc07e089492bbc238cf8bd39714c.png";